import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const PersonalSkeleton = () => <MultipleInputSkeleton count={6} />

export default memo(PersonalSkeleton)
